<template>
  <div class="rich-text">
    <p v-for="paragraph in paragraphs" :key="paragraph.value" class="rich-text__paragraph">
      <span
        v-for="node in paragraph"
        :class="{
          'rich-text__text--bold' :
            node.nodeType === 'text' && node.marks.find(mark => mark.type === 'bold'),
          'rich-text__text--italic' :
            node.nodeType === 'text' &&  node.marks.find(mark => mark.type === 'italic'),
          'rich-text__text--underline' :
            node.nodeType === 'text' &&  node.marks.find(mark => mark.type === 'underline')
        }"
        :key="node.value"
      >
        <a
          class="rich-text__text--link"
          v-if="node.nodeType === 'hyperlink'"
          :href="node.data.uri"
        >{{node.content[0].value}}</a>
        {{node.value}}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'richText',
  props: ['textData', 'className', 'richText'],
  computed: {
    paragraphs() {
      return this.textData.content.map((paragraph) => paragraph.content);
    },
  },
};
</script>

<style>
.rich-text__paragraph {
  margin-bottom: 24px;
}

.rich-text__text--bold {
  font-weight: bold;
}

.rich-text__text--italic {
  font-style: italic;
}

.rich-text__text--underline {
  text-decoration: underline;
}

.rich-text__text--link,
.rich-text__text--link:active,
.rich-text__text--link:visited {
  font-weight: bold;
  color: var(--blue);
}
</style>
